import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  color: #000;
  font-family: Arial, sans-serif;

  @media print {
    height: auto;
    margin: 0;
    padding: 0;
    justify-content: flex-start;
  }
`

export const LabelBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 300px;

  @media print {
    border: none;
    width: 100%;
    padding: 0;
  }
`

export const Title = styled.h2`
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
  word-break: break-word;
`

export const Info = styled.p`
  font-size: 10px;
  margin-top: 10px;
  text-align: center;
  color: #555;

  @media print {
    color: #000;
  }
`
